import { getImageProps } from "@utilities/payload";
import NextImage from "next/image";
import { FetchCardsDataResult } from "./type";

export function buildCardsWithIcons(data: FetchCardsDataResult) {
  const cards = data.cards.map(card => {
    const customerLogoProps = card.customerLogo ? getImageProps(card.customerLogo, { fill: true }) : null;
    const customerLogoWhiteProps = card.customerLogoWhite
      ? getImageProps(card.customerLogoWhite, { fill: true })
      : null;

    return {
      id: card.id,
      industry: card.industry,
      description: card.description,
      href: card.href,
      icon: customerLogoProps ? (
        <div className='tw-relative tw-w-[120px] tw-h-[40px]'>
          <NextImage {...customerLogoProps} sizes='120px' alt='' className='tw-object-contain tw-object-center' />
        </div>
      ) : null,
      iconHover: customerLogoWhiteProps ? (
        <div className='tw-relative tw-w-[120px] tw-h-[40px]'>
          <NextImage {...customerLogoWhiteProps} sizes='120px' alt='' className='tw-object-contain tw-object-center' />
        </div>
      ) : undefined,
    };
  });

  return {
    cards,
    hasMore: data.hasMore,
    totalPages: data.totalPages,
  };
}
